import React from 'react'
import { useStore } from 'react-redux'
import PropTypes from 'prop-types'
import {
  getOption,
  getOptions,
  defaultGetText,
  defaultGetValue
} from 'utils/searchField'
import MultiGroupedSearchField from '../Basic/MultiGroupedSearchField'

const UniversalMultiGroupedSearchField = props => {
  const { api, params, itemText, ...rest } = props
  const store = useStore()
  return (
    <MultiGroupedSearchField
      getText={(a) => {
        return defaultGetText(itemText)(a)
      }}
      getValue={defaultGetValue(['id'])}
      getOptions={search => getOptions(store, { api, params, search })}
      getOption={getOption(store, { api, params })}
      isMulti={true}
      itemText={itemText}
      {...rest}
    />
  )
}

UniversalMultiGroupedSearchField.propTypes = {
  api: PropTypes.string.isRequired,
  params: PropTypes.object,
  itemText: PropTypes.array,
}

UniversalMultiGroupedSearchField.defaultProps = {
  itemText: ['name']
}

export default UniversalMultiGroupedSearchField
